import { Accordion, AccordionVariant } from '@aus-platform/design-system';
import React from 'react';
import type { DrillBlastRequestHistoryItem } from 'shared/api/workspace';
import { CustomDate, DateTimeFormatLength } from 'src/shared/utils';

type DrillAndBlastHistoryAccordionItemProps = {
  item: DrillBlastRequestHistoryItem;
};

export const DrillAndBlastHistoryAccordionItem: React.FC<
  DrillAndBlastHistoryAccordionItemProps
> = ({ item }) => {
  const formattedCreatedAt = new CustomDate(item.createdAt).formatDate(
    DateTimeFormatLength.Long,
  );

  return (
    <Accordion variant={AccordionVariant.ChevronRight}>
      <Accordion.Item
        eventKey={String(item.id)}
        title={
          <div className="history__header">
            <div className="history__title">{item.title}</div>
            <div className="history__subtitle">
              Requested on {formattedCreatedAt}
            </div>
          </div>
        }
      >
        <div className="history__content">
          <div className="history__row">
            <div>
              <div className="history__label">Spacing</div>
              <div className="history__value">
                {item.spacing ? `${item.spacing} m` : '-'}
              </div>
            </div>
            <div>
              <div className="history__label">Required Burden</div>
              <div className="history__value">
                {item.burden ? `${item.burden} m` : '-'}
              </div>
            </div>
          </div>
          <div className="history__row">
            <div>
              <div className="history__label">Base Elevation</div>
              <div className="history__value">
                {item.baseElevation ? `${item.baseElevation} m` : '-'}
              </div>
            </div>
            <div>
              <div className="history__label">Expected Number of Holes</div>
              <div className="history__value">
                {item.expectedNumberOfHoles ?? '-'}
              </div>
            </div>
          </div>
          <div className="history__row">
            <div>
              <div className="history__label">Drill Pattern</div>
              <div className="history__value">{item.drillPattern ?? '-'}</div>
            </div>
            <div>
              <div className="history__label">Explosive Type</div>
              <div className="history__value">{item.explosiveType ?? '-'}</div>
            </div>
          </div>
        </div>
      </Accordion.Item>
    </Accordion>
  );
};
